var map = {
	"./avatar2.png": "096f",
	"./avatar3.png": "5483",
	"./avatar4.png": "b009",
	"./avatar5.png": "b715",
	"./avatar6.png": "ea43",
	"./avatar7.png": "375c",
	"./avatar8.png": "62a8",
	"./avatar9.png": "9880"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3db";